import { faInfoCircle } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Divider, Typography } from "@mui/material"
import { translate } from "app/language/service"
import { IForm } from "form/model"
import React from "react"
import { FlexBox } from "ui/components/FlexBox"
import { FieldWeathers } from "../../fields/FieldWeathers"
import { FieldWeekScheduler } from "../../fields/FieldWeekScheduler"

interface IConfigurationScheduleFormProps {
  form: IForm
  readOnly?: boolean
}

export const ConfigurationScheduleForm = React.memo(
  ({ form, readOnly }: IConfigurationScheduleFormProps): JSX.Element => {
    const {
      context,
      configuration: { schedule }
    } = form
    const scheduleErrors = context.configuration.errors.schedule
    return (
      <FlexBox
        vertical
        ai="start"
        jc="start"
        gap
        fullWidth
        sx={{
          height: "100%",
          minHeight: "100%",
          maxHeight: "100%",
          p: "1rem"
        }}>
        <FieldWeekScheduler
          id="schedule-items"
          items={schedule.scheduleItems}
          noSchedule={schedule.noSchedule}
          disabled={readOnly}
          scheduleErrors={scheduleErrors}
        />
        <Divider sx={{ width: "100%", mt: "1rem" }} />
        <FlexBox vertical jc="flex-start" ai="flex-start" fullWidth>
          <Typography color="textPrimary" sx={{ borderBottom: "none !important", fontWeight: 500 }}>
            {translate("label.weather.title")}
          </Typography>
          <FlexBox fullWidth gap>
            <FontAwesomeIcon icon={faInfoCircle} />
            <Typography color="textSecondary" sx={{ fontSize: ".9rem" }}>
              {translate("label.info.weather.no.forecast")}
            </Typography>
          </FlexBox>
        </FlexBox>
        <FieldWeathers
          weathers={schedule.weathers}
          disabled={readOnly}
          scheduleErrors={scheduleErrors}
          min_celsius={schedule.min_celsius}
          max_celsius={schedule.max_celsius}
        />
      </FlexBox>
    )
  }
)
